export default __webpack_public_path__ + "static/media/VI-logo-new.f54707f8.png";